import { format } from 'date-fns';

export const getClubValue = club => club.entities_id ?? club.club_entities_id ?? club.club_id ?? '';
export const getClubLabel = club => club.name ?? club.club_name ?? club.short_name ?? 'Klub';
export const getClubGuide = club => club.entities_guide ?? club.club_entities_guide ?? null;

export const getDurationValue = option =>
  option.contract_durations_id ?? option.id ?? option.value ?? '';

export const getDurationLabel = option =>
  option.name ?? option.contract_duration_name ?? option.label ?? 'Trajanje';

export const getTerminationValue = option =>
  option.contract_terminations_id ?? option.id ?? option.value ?? '';

export const getTerminationLabel = option =>
  option.name ?? option.contract_termination_name ?? option.label ?? 'Osnov';

export const getContactValue = contact =>
  contact.entities_contact_id ??
  contact.authorized_contact_id ??
  contact.contact_id ??
  contact.id ??
  contact.contact_guid ??
  '';

export const getContactLabel = contact => {
  const baseLabel =
    contact.name || contact.email || contact.phone_1 || contact.phone_2 || contact.phone_3 || 'Kontakt';

  const contactTypeLabel = contact.contact_type_name || contact.nam_contact_type;

  if (contactTypeLabel) {
    return `${baseLabel} (${contactTypeLabel})`;
  }

  return baseLabel;
};

export const toInputDate = value => {
  if (!value) {
    return '';
  }

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return '';
  }

  return format(date, 'yyyy-MM-dd');
};

export const formatDateTime = value => {
  if (!value) {
    return '';
  }

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return '';
  }

  return format(date, 'dd.MM.yyyy');
};

export const createInitialContract = contract => ({
  ...contract,
  club_entities_id: contract?.club_entities_id ?? contract?.entities_id ?? '',
  players_entities_id: contract?.players_entities_id ?? '',
  authorized_contact_id: contract?.authorized_contact_id ?? '',
  contract_durations_id: contract?.contract_durations_id ?? '',
  valid_to: toInputDate(contract?.valid_to),
  contract_terminations_id: contract?.contract_terminations_id ?? '',
  terminated_at: toInputDate(contract?.terminated_at),
  club_scan_document_path: contract?.club_scan_document_path ?? '',
  signed_scan_document_path: contract?.signed_scan_document_path ?? ''
});

export const normalizeContractResponse = response => {
  if (Array.isArray(response)) {
    return response[0] || null;
  }

  const nestedResponse = response?.contract ?? response?.item ?? response?.document;
  if (nestedResponse) {
    return normalizeContractResponse(nestedResponse);
  }

  if (Array.isArray(response?.data)) {
    return response.data[0] || null;
  }

  if (response?.data && typeof response.data === 'object') {
    const { data, ...rest } = response;
    return { ...rest, ...data };
  }

  return response || null;
};

export const getContractGuid = contract =>
  contract?.document_guid ?? contract?.contracts_guid ?? contract?.contract_guid ?? null;

export const normalizeContractPayload = contract => ({
  club_entities_id: contract.club_entities_id || null,
  players_entities_id: contract.players_entities_id || null,
  authorized_contact_id: contract.authorized_contact_id || null,
  contract_durations_id: contract.contract_durations_id || null,
  valid_to: contract.valid_to || null,
  contract_terminations_id: contract.contract_terminations_id || null,
  terminated_at: contract.terminated_at || null,
  ...(contract.club_scan_document_path instanceof File
    ? { club_scan_document_path: contract.club_scan_document_path }
    : {}),
  ...(contract.signed_scan_document_path instanceof File
    ? { signed_scan_document_path: contract.signed_scan_document_path }
    : {})
});
